import * as React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/types"
import { CmsAuthorizationModal } from "@modules/cms/authorization/components/CmsAuthorizationModal"
import { CmsIntegrationDeleteForm } from "../components/CmsIntegrationDeleteForm"
import { CmsProvider, CmsVendor } from "@modules/graphql/types"

export function useCmsIntegrationControls(
  siteId: string,
  orgSiteName: string,
  cmsVendorsToProvision: CmsVendor[] = []
) {
  const [cmsToEdit, setCmsToEdit] = React.useState<CmsProvider | null>(null)
  const [cmsToRemove, setCmsToRemove] = React.useState<CmsProvider | null>(null)

  return {
    setCmsToEdit,
    setCmsToRemove,
    controlModals: (
      <React.Fragment>
        {cmsToEdit && (
          <CmsAuthorizationModal
            closeModal={() => setCmsToEdit(null)}
            siteId={siteId}
            formattedName={cmsToEdit?.formattedName || ""}
            isConnected={!!cmsToEdit.connected}
            orgSiteName={orgSiteName}
            name={cmsToEdit.name}
            siteType={
              cmsVendorsToProvision.includes(cmsToEdit.name)
                ? OnboardingSiteType.DeployNowProvision
                : OnboardingSiteType.Create
            }
            isOpen={Boolean(cmsToEdit)}
          />
        )}

        {cmsToRemove && (
          <CmsIntegrationDeleteForm
            siteId={siteId}
            cms={cmsToRemove}
            onDismiss={() => setCmsToRemove(null)}
          />
        )}
      </React.Fragment>
    ),
  }
}
